import { auth, provider } from "../firebase";
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signInWithRedirect,
} from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) navigate("/home");
    });
  }, []);

  return (
    <form
      autoComplete="off"
      className="flex justify-center items-center mt-24 dark:text-slate-300"
      onSubmit={(e: any) => {
        e.preventDefault();
        signInWithEmailAndPassword(auth, e.target[0].value, e.target[1].value)
          .then(() => {
            navigate("/home");
          })
          .catch((error) => {
            let errorMessage = error.code;
            errorMessage = errorMessage.split("/").pop();
            errorMessage = errorMessage?.replace(/-/g, " ");
            errorMessage =
              errorMessage?.charAt(0).toUpperCase() + errorMessage?.slice(1);
            setError(errorMessage);
          });
      }}
    >
      <div className="w-9/12">
        <div className="text-center">
          <h1 className="text-3xl font-bold mb-3 dark:text-slate-300">
            Hello Again!
          </h1>
          <p className="text-slate-600 dark:text-slate-500 italic font-medium select-none mb-12">
            Welcome back to the
            <span className="text-blue-600 dark:text-blue-400">
              {" "}
              TVmaze App
            </span>
          </p>
        </div>
        <div className="group border-b-2 border-blue-200 dark:border-slate-600 p-1.5 mb-7 focus-within:border-blue-600 dark:focus-within:border-blue-400 select-none flex flex-nowrap">
          <label
            htmlFor="email"
            className=" mr-4 ml-2 text-slate-600 dark:text-slate-500 group-focus-within:text-blue-700 dark:group-focus-within:text-blue-400"
          >
            {/* prettier-ignore */}
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6" > <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" /> </svg>
          </label>
          <input
            type="email"
            name="email"
            id="email"
            className="placeholder:italic placeholder:font-semibold dark:placeholder:text-slate-500 focus:outline-none bg-transparent w-full"
            placeholder="Email"
            required
            onInput={() => {
              if (error) setError(null);
            }}
          />
        </div>
        <div className="group border-b-2 border-blue-200 dark:border-slate-600 p-1.5 mb-10 focus-within:border-blue-600 dark:focus-within:border-blue-400 select-none flex flex-nowrap">
          <label
            className=" mr-4 ml-2 text-slate-600 dark:text-slate-500 group-focus-within:text-blue-700 dark:group-focus-within:text-blue-400 cursor-pointer"
            onClick={() => {
              setShowPassword(!showPassword);
            }}
          >
            {showPassword ? (
              /* prettier-ignore */
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6" > <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" /> </svg>
            ) : (
              /* prettier-ignore */
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6" > <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" /> <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /> </svg>
            )}
          </label>
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            className="placeholder:italic placeholder:font-semibold dark:placeholder:text-slate-500 focus:outline-none bg-transparent w-full"
            placeholder="Password"
            required
            onInput={() => {
              if (error) setError(null);
            }}
          />
        </div>
        <button className="bg-blue-600 dark:bg-blue-500 w-full text-white dark:text-slate-100 font-bold text rounded-full p-3 mb-5">
          Login
        </button>
        <p className="text-sm	italic text-slate-600 dark:text-slate-500 text-center mb-5 select-none">
          or continue with
        </p>
        <div className="flex justify-around mb-7 dark:fill-slate-200">
          <button
            className="py-3 px-10 border-2 border-blue-400 rounded-full select-none"
            onClick={() => {
              signInWithRedirect(auth, provider);
            }}
          >
            {/* prettier-ignore */}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 512" className="w-4 h-4" > <path d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z" /> </svg>
          </button>
        </div>
        <p className=" text-xs font-medium text-slate-600 dark:text-slate-500 italic select-none text-center">
          Not Registered yet?
          <Link
            className="text-blue-600 dark:text-blue-400 underline"
            to={"/signup"}
          >
            {" "}
            Signup Now!
          </Link>
        </p>
      </div>
      {error ? (
        <div
          className="py-2 px-3 text-sm text-red-800 bg-red-200 rounded-xl absolute bottom-12"
          role="alert"
        >
          <p className="text-red-600 text-sm italic">
            <span className="font-bold">Error! </span>
            {error}
          </p>
        </div>
      ) : null}
    </form>
  );
};

export default Login;
